import React from 'react';
import { GroupBase } from 'react-select';

import { OptionType } from './model';

export const formatGroupLabel = (data: GroupBase<OptionType>) => <div>{data.label}</div>;
